const allowedCharacters = [['&amp;', '&']];

/**
 * @link https://remarkablemark.org/blog/2019/11/29/javascript-sanitize-html/
 * */
function escapeHTML(input: string): string {
  if (typeof document === 'undefined') {
    throw Error('This function requires `document` to work');
  }

  const element = document.createElement('div');
  element.innerText = input;
  let output = element.innerHTML;

  allowedCharacters.forEach(([entity, character]) => {
    output = output.replaceAll(entity, character);
  });

  return output;
}

export default escapeHTML;
